
const stampsSolver = v => (!v || !v.split) ? null : v
  .split(/[,;.]/)
  .filter(str => str.length > 0)
  .join(', ');

export default stampsSolver;
